import { useAuth } from "./use-auth";

export const useTokenData = (prop) => {
  const { tokenData } = useAuth();
  return prop ? tokenData[prop] : tokenData;
};
